import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, defer, Observable, switchMap } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { LogInstanceToken } from '@evorait/pace-logging';

@Injectable()
export class PaceAuth0XIdTokenInterceptor implements HttpInterceptor {
    private readonly log = inject(LogInstanceToken);
    private readonly auth = inject(AuthService);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!navigator.onLine) {
            return next.handle(req);
        }

        return defer(() => this.auth.getAccessTokenSilently()).pipe(
            catchError((error) => {
                this.log.error('Error acquiring Auth0 token silently', error);
                return this.auth.loginWithRedirect().pipe(switchMap(() => this.auth.getAccessTokenSilently()));
            }),
            switchMap((token) => {
                if (token) {
                    const authReq = req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    return next.handle(authReq);
                }
                return next.handle(req);
            }),
        );
    }
}
